var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { QuestionScore } from '../../../classes/question/modules/QuestionScore';
import { QuestionAnswerState } from '../../../classes/learnware/LearnwareEnums';
export class MemorizePointsScore extends QuestionScore {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get maxPoints() {
        return this.question.memorizePointsStore.haveToKnow;
    }
    get reachedPoints() {
        // if (this.question.wordTask.wordTaskEvaluator.isCorrect) return this.maxPoints;
        return this.question.memorizePointsEvaluator.correctWordTasks.length;
    }
    get progressiveReachablePoints() {
        return this.question.memorizePointsEvaluator.completedWordTasks.length;
    }
    get shouldSetCompletedTimestamp() {
        if (!this.question.answer)
            return false;
        if (this.question.answer.completeDate)
            return false;
        if (this.question.answeringState.currentAnswerState !== QuestionAnswerState.Answering)
            return false;
        if (this.question.memorizePointsEvaluator.numberOfCompletedWordTasks >= this.question.numberOfTasksToComplete) {
            return true;
        }
        return false;
    }
    get legacyEvalText() {
        return this.question.wordTasks
            .map(wordTask => `${wordTask.wordTaskEvaluate.isCorrectToCurrentInput ? '1' : '0'}&&&${wordTask.wordTaskInput.manifestedInputValue}`)
            .join('|||');
    }
    set legacyEvalText(t) {
        const pieces = t.split('|||');
        for (let i = 0; i < pieces.length; i++) {
            const pieces2 = pieces[i].split('&&&');
            if (pieces2.length > 1) {
                this.question.wordTasks[i].wordTaskInput.manifestedInputValue = pieces2[1];
            }
        }
    }
}
__decorate([
    override
], MemorizePointsScore.prototype, "maxPoints", null);
__decorate([
    override
], MemorizePointsScore.prototype, "reachedPoints", null);
__decorate([
    override
], MemorizePointsScore.prototype, "progressiveReachablePoints", null);
__decorate([
    override
], MemorizePointsScore.prototype, "shouldSetCompletedTimestamp", null);
